import IconTabulations from './icon-tabulations';

export default class IconTabulationsDesktop extends IconTabulations {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/icon-tabulations/icon-tabulations.desktop.js